import { QpMessageFadeindownProvider } from "./qp-message-fadeindown.provider";

let module_name = "qpui.bootstrap.messageFedeindown";

let messageFadeindownModule = angular.module(module_name, []);

messageFadeindownModule.run(["$templateCache", function ($templateCache) {
    $templateCache.put("qp-message-fadeindown-template.html", require('./qp-message-fadeindown.html').default);
}])


messageFadeindownModule.provider("qpMessageFadeindown", QpMessageFadeindownProvider);

export { messageFadeindownModule, module_name }